document.addEventListener("DOMContentLoaded", function(event) {
    window.addEventListener("load", function () {
        // gsap.matchMedia initialisieren
        let mm = gsap.matchMedia();

        if( elements = getElements(document.querySelectorAll('.factList'))) {
            gsap.registerPlugin(ScrollTrigger);

            // Animation für Viewports, die kleiner oder gleich 600px sind
            mm.add("(max-width: 1023px)", () => {
                elements.forEach(function (element) {
                    let facts = gsap.utils.toArray(element.querySelectorAll('.fact'));


                    let progressElement = document.querySelector(".progressBar");

                    // get the height of the highest .fact element
                    let height = 0;
                    facts.forEach((fact, i) => {
                        if( fact.offsetHeight > height ) {
                            height = fact.offsetHeight;
                        }
                    });

                    // set the height of all .fact elements to the highest height
                    facts.forEach((fact, i) => {
                        fact.style.height = height + "px";
                    });

                    // remove first fact, because it should be the start fact
                    //facts.shift();

                    // set the height of the container with the .facts class to the highest height
                    element.querySelector('.facts').style.height = height + "px";

                    var end = facts.length * height;

                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            start: "top top",
                            end: "+=" + end,
                            scrub: true,
                            pin: true,
                            anticipatePin: 1,
                            snap: {
                                snapTo: "labelsDirectional",
                                duration: 0.8,
                            },
                            //markers: true,
                            onUpdate: self => {  // onUpdate wird bei jedem Scroll-Event ausgeführt
                                // Setzen Sie die Breite des Fortschrittsleisten-Elements auf den Fortschritt der ScrollTrigger-Instanz
                                gsap.set(progressElement, { width: `${self.progress * 100}%` });
                            }
                        }
                    });

                    facts.forEach((fact, i) => {
                        tl
                            .addLabel("start" + i)
                            .from(fact, { xPercent: 100 })
                            .from(fact.querySelector('.number'), { autoAlpha: 0, yPercent: 100 }, "<")
                            .from(fact.querySelector('h3'), { autoAlpha: 0, xPercent: 100 }, "<")
                            .from(fact.querySelector('p'), { autoAlpha: 0, xPercent: 100 }, "<0.1")
                        ;
                    });

                    // add end label
                    tl.addLabel("end");
                });
            });

            // Animation für Viewports, die größer als 600px sind
            mm.add("(min-width: 1024px)", () => {
                elements.forEach(function (element) {
                    let facts = gsap.utils.toArray(element.querySelectorAll('.fact'));

                    let progressElement = document.querySelector(".progressBar"); // Ihr Fortschrittsleisten-Div

                    // get the height of the highest .fact element
                    let height = 0;
                    facts.forEach((fact, i) => {
                        if( fact.offsetHeight > height ) {
                            height = fact.offsetHeight;
                        }
                    });

                    // set the height of all .fact elements to the highest height
                    facts.forEach((fact, i) => {
                        fact.style.height = height + "px";
                    });

                    // remove first fact, because it should be the start fact
                    //facts.shift();

                    // set the height of the container with the .facts class to the highest height
                    element.querySelector('.facts').style.height = height + "px";

                    var end = facts.length * height;
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            start: "30% top",
                            end: "+=" + end,
                            scrub: true,
                            pin: true,
                            anticipatePin: 1,
                            snap: {
                                snapTo: "labelsDirectional",
                                duration: 0.8,
                            },
                            //markers: true,
                            onUpdate: self => {  // onUpdate wird bei jedem Scroll-Event ausgeführt
                                // Setzen Sie die Breite des Fortschrittsleisten-Elements auf den Fortschritt der ScrollTrigger-Instanz
                                gsap.set(progressElement, { width: `${self.progress * 100}%` });
                            }
                        }
                    });

                    facts.forEach((fact, i) => {
                        tl
                            .addLabel("start" + i)
                            .from(fact, { xPercent: 100 })
                            .from(fact.querySelector('.number'), { autoAlpha: 0, yPercent: 100 }, "<")
                            .from(fact.querySelector('h3'), { autoAlpha: 0, xPercent: 100 }, "<")
                            .from(fact.querySelector('p'), { autoAlpha: 0, xPercent: 100 }, "<0.1")
                            .addLabel("end" + i)
                        ;
                    });

                    // add end label
                    tl.addLabel("end");

                    function labelToScroll(timeline, label) {
                        let st = timeline.scrollTrigger;
                        return st.start + (st.end - st.start) * (timeline.labels[label] / timeline.duration());
                    }

                    // scroll to fact on click
                    facts.forEach((fact, i) => {
                        number = fact.querySelector('.number');
                        number.addEventListener('click', function(e) {
                            label = "end" + i;
                            gsap.to(window, {scrollTo: labelToScroll(tl, label), duration: 1});
                        });
                    });
                });
            });
        }
    });
});
